import React, { useContext } from "react";
import { ConfigContext } from "../Context/ConfigContext";
import { Navigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";

const isTokenExpired = (token) => {
    try {
        const { exp } = jwtDecode(token);
        if (!exp) return true;
        const currentTime = Date.now() / 1000;
        return exp < currentTime;
    } catch (error) {
        console.error("Failed to decode token:", error);
        return true;
    }
};

const ProtectedRoutes = ({ routeName, children }) => {
    const { token, auth_routes,user_role } = useContext(ConfigContext);

    if (!token || isTokenExpired(token)) {
        return <Navigate to="/login" replace />;
    }
    if (user_role ==="qr") {
        return <Navigate to="/Qr" replace />;
    }

    if (!auth_routes.includes(routeName)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
};

export default ProtectedRoutes;
